import { Note } from '../model/notification/note';
import { NotificationType } from '../enum/notification-type.enum';
import { Style } from '../enum/style.enum';

export class NoteBuilder {
  private note: Note;

  constructor(title: string, icon = '', content = '') {
    this.note = new Note(title, icon, content);
    return this;
  }

  setContent(content: string): NoteBuilder {
    this.note.content = content;
    return this;
  }

  setInfo(info: string): NoteBuilder {
    this.note.info = info;
    return this;
  }

  setType(type: NotificationType): NoteBuilder {
    this.note.type = type;
    return this;
  }

  setStyle(style: Style): NoteBuilder {
    this.note.style = style;
    return this;
  }

  setAutoClose(autoClose: boolean): NoteBuilder {
    this.note.autoClose = autoClose;
    return this;
  }

  setCanClose(canClose: boolean): NoteBuilder {
    this.note.canClose = canClose;
    return this;
  }

  setTime(time: number): NoteBuilder {
    this.note.time = time;
    return this;
  }

  setAlertNote(): NoteBuilder {
    this.setCanClose(true);
    this.setAutoClose(false);
    this.setTime(4000);
    this.setType(NotificationType.alert);
    this.setStyle(Style.danger);
    return this;
  }

  setInfoNote(): NoteBuilder {
    this.setCanClose(true);
    this.setAutoClose(true);
    this.setTime(4000);
    this.setType(NotificationType.confirm);
    this.setStyle(Style.info);
    return this;
  }

  setSpinnerNote(): NoteBuilder {
    this.setAutoClose(false);
    this.setType(NotificationType.spinner);
    this.setStyle(Style.spinner);
    this.setIsLoading(true);
    return this;
  }

  setIsLoading(isLoading: boolean): NoteBuilder {
    this.note.isLoading = isLoading;
    return this;
  }

  setIndex(index: number): NoteBuilder {
    this.note.index = index;
    return this;
  }

  build(): Note {
    return this.note;
  }
}
